<template>
  <div class="locale-switcher pull-right" style="margin-top:3px;margin-right:9px;font-size:15px;">
    <!-- EL COMBO SELECTOR DE IDIOMAS LO PRESENTA SÓLO SI EL EVENTO TIENE VARIOS IDIOMAS HABILITADOS -->
    <!-- {{ locales }}
    <br><br>
    {{ list_locales }} -->
    <template v-if="available_langs">
    <select name="localeSwitcher" :value="$i18n.locale" @change.prevent="changeLocale">
      <option :value="l_locale.code" v-for="l_locale in list_locales" :key="l_locale.code" >
         <!-- <img
            :src="rutaImagen(l_locale.code)" 
            width="16"
            height="11"
          /> -->
         {{l_locale.name}}</option> 
    </select>
    <!-- <div class="social-buttons">
      <ul class="social">
        <li v-for="l_locale in list_locales" :key="l_locale.code">
          <img
            :src="rutaImagen(l_locale.code)"
            width="16"
            height="11"
            :title="l_locale.name"
            @click="changeLocale"
          />
        </li>
        <li>
          <img
            src="@/assets/img/idioma_pt.png"
            width="16"
            height="11"
            title="Portugues"
            @click="idioma('pt')"
          />
        </li>
        </ul>
    </div> -->
    </template>
  </div>
</template>

<script>
import i18n, { loadLocaleMessages} from "@/i18n"
import {
  setDocumentDirectionPerLocale,
  setDocumentLang,
  setDocumentTitle
} from "@/util/i18n/document"
import { getSupportedLocales } from "@/util/i18n/supported-locales"
export default {
  data: () => (
    { locales: getSupportedLocales(),
      list_locales: []
    }),
    
  computed:{
    available_langs(){
      if (this.list_locales.length <= 0) {
        this.locales.forEach(element => {
        // console.log("Element" + element.code + "-" + element.name)
        if (this.$store.state.evento.idiomas.includes(element.code) ){
        //     && !this.list_locales.includes(element.code)) {
          this.list_locales.push(element)
        }  
        //locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
        });
        return true
      } else {
        return true
      }
      
    },
  },
  methods: {
    rutaImagen (l_code) {
      return "/assets/img/idioma_" + l_code + ".png"
    },
    changeLocale(e) {
      const locale = e.target.value
      if (this.$i18n.locale !== locale) {
        loadLocaleMessages(locale).then(() => {
          setDocumentLang(locale);
          setDocumentDirectionPerLocale(locale);
          setDocumentTitle(i18n.t("app.title"));

          const to = this.$router.resolve({ params: {locale} }) // <-------------------- sacado de otro articulo
          this.$router.push(to.location)
        })
        // console.log('Idioma: '+ locale)
      }
    },
    // idiomaContains(n) {
    //   if (this.$store.state.evento_detalles.idiomas) {
    //     return this.$store.state.evento_detalles.idiomas.includes(n);
    //   } else {
    //     return false;
    //   }
    // },
  }
}
</script>
<style scoped>
li {
  text-decoration: underline;
  /* color: #459CE7; */
  color: var(--iq-primary);
}
</style>